import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.less";
import routes from "routes/routes";
import RouteWithSubRoutes from "routes/routeWithSubRoutes";
import ErrorBoundary from "common/components/errorBoundary/errorBoundary";
import User from "models/user/user";
import { fetchUserDetails, userDetails } from "redux/roles/userRoleSlice";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "common/components/loadingSpinner/loadingSpinner";
import PusherNotification from "features/pusher/pusher";
import { initGA } from "features/googleAnalytics/googleAnalytics";
import {
  allDiaries,
  fetchAllDiaries,
  globalLoaderFlag,
  saveGlobalLoader,
} from "redux/diaries/diariesSlice";
import Spinner from "common/components/spinner/spinner";
import { saveGlobalSetting } from "redux/settings/settingSlice";
import NetworkCall from "network/networkCall";
import Request from "network/request";

function App() {
  const dispatch = useDispatch();
  const userData = useSelector(userDetails);
  const loader = useSelector(globalLoaderFlag);
  const diaries = useSelector(allDiaries);

  const [shouldLoad, setShouldLoad] = useState(false);
  const setUserDetailsInRedux = async () => {
    setShouldLoad(false);
    dispatch(fetchUserDetails());
    setShouldLoad(true);
  };

  const getGlobalSettings = async () => {
    try {
      const res = await NetworkCall.fetch(Request.getSettings(), false);
      const settings = res?.data?.tableListing;
      dispatch(
        saveGlobalSetting({
          [settings[0].key]: settings[0].value,
          [settings[1].key]: settings[1].value,
          [settings[2].key]: settings[2].value,
          [settings[3].key]: settings[3].value,
          [settings[4].key]: settings[4].value,
          [settings[5].key]: settings[5].value,
          [settings[6].key]: settings[6].value,
        })
      );
    } catch (error) {}
  };
  useEffect(() => {
    User.isTokenAvailable() && getGlobalSettings();
    initGA();
    if (User.isTokenAvailable() && Object.entries(userData).length === 0) {
      setUserDetailsInRedux();
      User.isUserctive() && !loader && dispatch(saveGlobalLoader(true));
      User.isUserctive() &&
        !loader &&
        diaries.length === 0 &&
        dispatch(fetchAllDiaries());
    } else {
      setShouldLoad(true);
    }
  }, []);

  return (
    <ErrorBoundary>
      {!loader ? (
        <div className="App">
          <Routes>
            {routes.map((route, i) => (
              <Route
                key={i}
                path={route.path}
                element={
                  <>
                    {User.isUserctive() && (
                      <PusherNotification></PusherNotification>
                    )}
                    <RouteWithSubRoutes route={route} userData={userData} />
                  </>
                }
              />
            ))}
          </Routes>
        </div>
      ) : (
        <Spinner flag={true}></Spinner>
      )}
    </ErrorBoundary>
  );
}

export default App;
